<template>
  <div class="bar-options-setting-dialog" ref="barSetting">
    <el-collapse v-model="sizeActiveNames">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
      <el-collapse-item name="2" class="paddingtb8">
        <template slot="title">
          <div class="tabs flex" :class="request_prefix === 'bigScreen' ? '' : 'home_tabs'">
            <div :class="tabsActive == 0 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 0)">
              数据组
            </div>
            <div :class="tabsActive == 1 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 1)">
              图例
            </div>
          </div>
        </template>
        <div class="setting-item">
          <template v-if="tabsActive == 0">
            <!--类型-->
            <cx-select class="mt8" v-if="showBarType" :value.sync="formatterSet" :selectOptions="typeSelectOptions" title="类型" />
            <!--柱宽-->
            <p  v-if="isStack || isRing" :class="showBarType ? 'mt16' : 'mt8'">柱体宽度</p>
            <slider-and-input
              v-if="isStack || isRing"
              inputWidth="large"
              inputHeight="small"
              :value.sync="barWidth"
              title=""
              titlePosition="singleLine"
              :sliderMax="sliderPercentMax"
              suffix="%"
            />
            <!--同数据组柱体间距-->
            <p class="mt16 mb8" v-if="isRing">数据组柱体间距</p>
            <slider-and-input
              v-if="isRing"
              inputWidth="large"
              inputHeight="small"
              :value.sync="barGap"
              title=""
              titlePosition="singleLine"
              :sliderMax="sliderPercentMax"
              suffix="%"
              class="mb8"
            />
            <!--圆角-->
            <div v-if="isStack" class="data-item mt16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                :sliderMax="sliderPercentMax"
              />
            </div>
            <!--柱体背景颜色-->
            <div v-if="isStack" class="data-item mt16 mb8">
              <div class="mb16">
                <el-checkbox v-model="showBackground">柱体背景颜色</el-checkbox>
              </div>
              <div v-if="showBackground" class="color-picker-container custom-button-bg width_100">
                <el-color-picker
                  class=""
                  v-model="backgroundStyleColor"
                  color-format="rgb"
                  :show-alpha="true"
                  :predefine="predefineColors"
                ></el-color-picker>
                <span class="floatLeft color-text mr8">{{ backgroundStyleColor }}</span>
              </div>
            </div>
            <numberSetting :options="options" :ids="ids"></numberSetting>
            <scrollSetting :options="options" :ids="ids" :isRing="isRing"></scrollSetting>

            <div v-for="(item, index) in seriesData" :key="index">
              <collapsibleItem
                :key="index"
                :name="'data' + index"
                :type="item.name"
                :is-active="collapse[item.name].isActive"
                @collapsibleItemClick="collapsibleItemClickHandle($event, index)"
              >
                <div slot="heading">{{ item.name }}</div>
                <div slot="body">
                  <!-- <BarSeriesSetting
                    v-if="
                      collapseDataActiveNames.length !== 0 &&
                      collapseDataActiveNames.find(it => it == index) > -1 &&
                      item.type == 'bar'
                    "
                    :options='options'
                    :seriesSettingItem="item"
                    :ids="ids"
                    :index="index"
                    :isStack="isStack"
                    :isRing="isRing"
                    ref="seriesSetting"
                    @barTypeChangeHandle="barTypeChangeHandle"
                  ></BarSeriesSetting> -->
                  <component
                    :is="item.type[0].toUpperCase() + item.type.slice(1) + 'SeriesSetting'"
                    :seriesSettingItem="item"
                    :seriesDataLen="seriesData.length"
                    :ids="ids"
                    :index="index"
                    :lineToBar="true"
                    :isStack="isStack"
                    :isRing="isRing"
                    :options="options"
                    :isBarToLine="isBarToLine"
                    ref="seriesSetting"
                    @barTypeChangeHandle="barTypeChangeHandle"
                    @barYAxisTypeChangeHandle="barYAxisTypeChangeHandle"
                  ></component>
                  <!-- <LineSeriesSetting
                    v-else-if="
                      collapseDataActiveNames.length !== 0 &&
                      collapseDataActiveNames.find(it => it == index) &&
                      item.type == 'line'
                    "
                    :seriesSettingItem="item"
                    :ids="ids"
                    :index="index"
                    :lineToBar="true"
                    ref="seriesSetting"
                    @barTypeChangeHandle="barTypeChangeHandle"
                  ></LineSeriesSetting> -->
                </div>
              </collapsibleItem>
            </div>
          </template>
          <template v-else>
            <legend-setting :options="options" :ids="ids"></legend-setting>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <chart-common-options-setting :options="options" :ids="ids"></chart-common-options-setting>
  </div>
</template>

<script>
import legendSetting from "toolbarComponents/bigScreen/common/options/legendSetting"
import ChartCommonOptionsSetting from "toolbarComponents/bigScreen/common/chart-common-options-setting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
import LineSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/lineSeriesSetting"
import BarSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/barSeriesSetting"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
import scrollSetting from "toolbarComponents/bigScreen/common/options/scrollSetting"
import numberSetting from "toolbarComponents/bigScreen/common/options/numberSetting"

import publicData from "toolbarComponents/bigScreen/common/options/publicData"
// 引入默认折线图样式
import { chartOption1 } from "materials/bigScreen/line/menus/difference_options/allTypeCharOptions/chartOption1"
import { chartOption1 as barChartOption1 } from "materials/bigScreen/bar/menus/difference_options/allTypeCharOptions/chartOption1"

export default {
  name: "bar-options-setting",
  components: {
    ChartCommonOptionsSetting,
    ChartCommonOptionsSetting1,
    BarSeriesSetting,
    LineSeriesSetting,
    controlWidthAndSizeAndZindex,
    legendSetting,
    scrollSetting,
    numberSetting
  },
  mixins: [publicData],
  props: {
    options: Object
  },
  data() {
    return {
      this1: this,
      sizeActiveNames: ["1", "2", "3"],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      tabsActive: 0, //  显示数据组还是图例
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      singleColorDefault: "rgba(0, 71, 255, 1)",
      multiColorDefault: {
        startColor: "#5A81FF",
        endColor: "#4BDFFF"
      },
      collapseDataActiveNames: [],
      changeStatus: false,
      oldBarSeries: [],
      oldLineSeries: [],
      typeSelectOptions: [
        {
          label: "双向柱状图",
          value: 1
        },
        {
          label: "正负柱状图",
          value: 2
        }
      ]
    }
  },
  watch: {
    seriesData: {
      handler(newVal, oldVal) {
        if (JSON.parse(JSON.stringify(newVal)) !== JSON.parse(JSON.stringify(oldVal))) this.init()
      },
      deep: true
    }
  },
  created() {
    this.init()
    // this.isBarToLine
  },

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    // 动态数据
    seriesData: {
      get() {
        if (this.options.chartOption.series) {
          // console.log(this.options.chartOption.series)
          if(this.options.chartOption.styleId === 12){
            let obj1 = this.options.chartOption.series[0]
            return [obj1]
          }else{
            return this.options.chartOption.series
          }
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption", false)
      }
    },
    isBarToLine: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.chartOption, "isBarToLine", "isBarToLine", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isBarToLine", false)
      }
    },
    // 判断是否为堆叠柱状图
    isStack: {
      get() {
        return !!this.hasProperty(this.options.chartOption.series[0], "stack")
      }
    },
    // 判断是否为环形柱状图
    isRing: {
      get() {
        return this.options?.chartOption?.seriesTempAttributes?.coordinateType === "polar"
      }
    },
    barWidth: {
      get() {
        return parseInt(this.options.chartOption.series[this.options.chartOption.series.length - 1].barWidth)
      },
      set(newVal) {
        if (newVal !== this.barWidth) {
          if (this.isRing) {
            for (let i = 0; i < this.options.chartOption.series.length; i++) {
              this.$changeOptionsEV(newVal + "%", "chartOption.series." + i + ".barWidth", false)
            }
          } else {
            for (let i = 0; i < this.options.chartOption.series.length; i++) {
              this.$changeOptionsEV(newVal, "chartOption.series." + i + ".barWidth", false)
            }
          }
        }
      }
    },
    barGap: {
      get() {
        return parseInt(this.options.chartOption.series[this.options.chartOption.series.length - 1].barGap)
      },
      set(newVal) {
        if (newVal !== this.barGap) {
          if (this.isRing) {
            for (let i = 0; i < this.options.chartOption.series.length; i++) {
              this.$changeOptionsEV(newVal + "%", "chartOption.series." + i + ".barGap", false)
            }
          }
        }
      }
    },
    borderTypeFlag: {
      get() {
        if (this.isStack) {
          return Array.isArray(this.options.chartOption.seriesTempAttributes.borderRadius) ? 1 : 2
        }
      },
      set(val) {
        if (val == 2) {
          this.$changeOptionsEV(this.borderRadius, "chartOption.seriesTempAttributes.borderRadius", false)
          if(this.options.chartOption.styleId === 6){
            this.$changeOptionsEV([0, 0, this.borderRadius, this.borderRadius], "chartOption.series." + 0 + ".itemStyle.borderRadius", false)
            this.$changeOptionsEV(
                [this.borderRadius, this.borderRadius, 0, 0],
                "chartOption.series." + (this.options.chartOption.series.length - 1) + ".itemStyle.borderRadius",
                false
            )
          }else{
            for (let i = 0; i < this.options.chartOption.series.length; i++) {
              this.$changeOptionsEV(this.borderRadius, "chartOption.series." + i + ".itemStyle.borderRadius", false)
            }
          }
        } else {
          let bdRadius = [
            this.borderTopLeftRadius,
            this.borderTopRightRadius,
            this.borderBottomRightRadius,
            this.borderBottomLeftRadius
          ]
          this.$changeOptionsEV(bdRadius, "chartOption.seriesTempAttributes.borderRadius", false)
          if(this.options.chartOption.styleId === 6){
            this.$changeOptionsEV(
              [0, 0, this.borderBottomRightRadius, this.borderBottomLeftRadius],
              "chartOption.series." + 0 + ".itemStyle.borderRadius",
              false
            )
            this.$changeOptionsEV(
              [this.borderTopLeftRadius, this.borderTopRightRadius, 0, 0],
              "chartOption.series." + (this.options.chartOption.series.length - 1) + ".itemStyle.borderRadius",
              false
            )
          }else{
            for (let i = 0; i < this.options.chartOption.series.length; i++) {
              this.$changeOptionsEV(bdRadius, "chartOption.series." + i + ".itemStyle.borderRadius", false)
            }
          }
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        if (Array.isArray(this.options.chartOption.seriesTempAttributes.borderRadius)) {
          return Number(this.options.chartOption.seriesTempAttributes.borderRadius[0])
        } else {
          return Number(this.borderRadius)
        }
      },
      set(newVal) {
        let bdRadius = [newVal, this.borderTopRightRadius, this.borderBottomRightRadius, this.borderBottomLeftRadius]
        this.$changeOptionsEV(bdRadius, "chartOption.seriesTempAttributes.borderRadius", false)
        if(this.options.chartOption.styleId === 6){
          this.$changeOptionsEV(
            [newVal, this.borderTopRightRadius, 0, 0],
            "chartOption.series." + (this.options.chartOption.series.length - 1) + ".itemStyle.borderRadius",
            false
          )
        }else{
          for (let i = 0; i < this.options.chartOption.series.length; i++) {
            this.$changeOptionsEV(bdRadius, "chartOption.series." + i + ".itemStyle.borderRadius", false)
          }
        }
      }
    },
    borderTopRightRadius: {
      get() {
        if (Array.isArray(this.options.chartOption.seriesTempAttributes.borderRadius)) {
          return Number(this.options.chartOption.seriesTempAttributes.borderRadius[1])
        } else {
          return Number(this.borderRadius)
        }
      },
      set(newVal) {
        let bdRadius = [this.borderTopLeftRadius, newVal, this.borderBottomRightRadius, this.borderBottomLeftRadius]
        this.$changeOptionsEV(bdRadius, "chartOption.seriesTempAttributes.borderRadius", false)
        if(this.options.chartOption.styleId === 6){
          this.$changeOptionsEV(
            [this.borderTopLeftRadius, newVal, 0, 0],
            "chartOption.series." + (this.options.chartOption.series.length - 1) + ".itemStyle.borderRadius",
            false
          )
        }else{
          for (let i = 0; i < this.options.chartOption.series.length; i++) {
            this.$changeOptionsEV(bdRadius, "chartOption.series." + i + ".itemStyle.borderRadius", false)
          }
        }
      }
    },
    borderBottomRightRadius: {
      get() {
        if (Array.isArray(this.options.chartOption.seriesTempAttributes.borderRadius)) {
          return Number(this.options.chartOption.seriesTempAttributes.borderRadius[2])
        } else {
          return Number(this.borderRadius)
        }
      },
      set(newVal) {
        let bdRadius = [this.borderTopLeftRadius, this.borderTopRightRadius, newVal, this.borderBottomLeftRadius]
        this.$changeOptionsEV(bdRadius, "chartOption.seriesTempAttributes.borderRadius", false)
        if(this.options.chartOption.styleId === 6){
          this.$changeOptionsEV(
            [0, 0, newVal, this.borderBottomLeftRadius],
            "chartOption.series." + 0 + ".itemStyle.borderRadius",
            false
          )
        }else{
          for (let i = 0; i < this.options.chartOption.series.length; i++) {
            this.$changeOptionsEV(bdRadius, "chartOption.series." + i + ".itemStyle.borderRadius", false)
          }
        }
      }
    },
    borderBottomLeftRadius: {
      get() {
        if (Array.isArray(this.options.chartOption.seriesTempAttributes.borderRadius)) {
          return Number(this.options.chartOption.seriesTempAttributes.borderRadius[3])
        } else {
          return Number(this.borderRadius)
        }
      },
      set(newVal) {
        let bdRadius = [this.borderTopLeftRadius, this.borderTopRightRadius, this.borderBottomRightRadius, newVal]
        this.$changeOptionsEV(bdRadius, "chartOption.seriesTempAttributes.borderRadius", false)
        if(this.options.chartOption.styleId === 6){
          this.$changeOptionsEV(
            [0, 0, this.borderBottomRightRadius, newVal],
            "chartOption.series." + 0 + ".itemStyle.borderRadius",
            false
          )
        }else{
          for (let i = 0; i < this.options.chartOption.series.length; i++) {
            this.$changeOptionsEV(bdRadius, "chartOption.series." + i + ".itemStyle.borderRadius", false)
          }
        }
      }
    },
    borderRadius: {
      get() {
        if (this.isStack) {
          if (Array.isArray(this.options.chartOption.seriesTempAttributes.borderRadius)) {
            return Number(this.options.chartOption.seriesTempAttributes.borderRadius[0])
          } else {
            return this.options.chartOption.seriesTempAttributes.borderRadius!=undefined ? Number(this.options.chartOption.seriesTempAttributes.borderRadius) : 0
          }
        }
      },
      set(newVal) {
        if (newVal !== this.borderRadius) {
          this.$changeOptionsEV(newVal, "chartOption.seriesTempAttributes.borderRadius", false)
          for (let i = 0; i < this.options.chartOption.series.length; i++) {
            this.$changeOptionsEV(newVal, "chartOption.series." + i + ".itemStyle.borderRadius", false)
          }
        }
      }
    },
    showBackground: {
      get() {
        return this.options.chartOption.series[0].showBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + 0 + ".showBackground", false)
      }
    },
    backgroundStyleColor: {
      get() {
        return this.options.chartOption.series[0].backgroundStyle.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + 0 + ".backgroundStyle.color", false)
      }
    },

    showBarType: {
      get() {
        // this.options.chartOption.series.forEach(item => {
        //   if (item.stack !== "Total") {
        //     return false
        //   }
        // })
        // if (
        //   this.options.chartOption.xAxis &&
        //   this.options.chartOption.xAxis.type === "value" &&
        //   this.options.chartOption.yAxis.type === "category"
        // ) {
        //   return true
        // }
        if (this.options.chartOption.showBarType) return true
        else return false
      }
    },
    formatterSet: {
      get() {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        return pluginName.indexOf("formaterValToAbsPlugin") > -1 ? 1 : 2
      },
      set(val) {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        if (val === 1) {
          //1 双向柱状图 带插件
          pluginName.includes("formaterValToAbsPlugin") ? "" : pluginName.push("formaterValToAbsPlugin")
        } else if (val === 2) {
          //2 正负柱状图 恢复默认设置
          let index = pluginName.indexOf("formaterValToAbsPlugin")
          pluginName.splice(index, 1)
          this.$changeOptionsEV(null, "chartOption.xAxis.axisLabel.formatter", false)
          this.$changeOptionsEV(null, "chartOption.tooltip.formatter", false)
        }
        this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
      }
    },
  },
  methods: {
    init() {
      // 图表类组件兼容以前老数据，没有seriesTempAttributes属性的数据
      if (!this.options.chartOption.seriesTempAttributes) {
        const seriesTempAttributes = {
          // 用于存放数据中的通用配置项
          coordinateType: "rectangular" //直角坐标系
        }
        this.$changeOptionsEV(seriesTempAttributes, "chartOption.seriesTempAttributes", false)
      }
      this.options.chartOption.series.forEach(item => {
        this.collapse[item.name] = {
          isActive: false,
          shape_isActive: false,
          text_isActive: false
        }
      })
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        if (val == "8") {
          return
        }
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    changeBorderRadiusType(value) {
      if (value == 2) {
        const newVal = this.borderTopLeftRadius
        this.$changeOptionsEV(newVal, "chartOption.seriesTempAttributes.borderRadius", false)
        for (let i = 0; i < this.options.chartOption.series.length; i++) {
          this.$changeOptionsEV(newVal, "chartOption.series." + i + ".itemStyle.borderRadius", false)
        }
      } else {
        let bdRadius = [this.borderRadius, this.borderRadius, this.borderRadius, this.borderRadius]
        this.$changeOptionsEV(bdRadius, "chartOption.seriesTempAttributes.borderRadius", false)
        this.$changeOptionsEV(
          [0, 0, this.borderRadius, this.borderRadius],
          "chartOption.series." + 0 + ".itemStyle.borderRadius",
          false
        )
        this.$changeOptionsEV(
          [this.borderRadius, this.borderRadius, 0, 0],
          "chartOption.series." + (this.options.chartOption.series.length - 1) + ".itemStyle.borderRadius",
          false
        )
      }
    },
    barTypeChangeHandle() {
      // debugger
      const type = arguments[0]
      const index = arguments[1]
      let defaultLineOptions = JSON.parse(JSON.stringify(chartOption1))
      defaultLineOptions.series[0].name = this.seriesData[index].name
      defaultLineOptions.series[0].data = this.seriesData[index].data
      defaultLineOptions.series[0].label = this.seriesData[index].label
      // 如果不删除这个属性折线图重新渲染不出来
      Reflect.deleteProperty(defaultLineOptions.series[0], "animationDelay")
      if (type == "bar") {
        this.oldLineSeries[index] = this.seriesData[index]
        this.oldLineSeries[index].type = "line"
        if(this.oldBarSeries[index] == undefined){
          let defaultBarOptions = JSON.parse(JSON.stringify(barChartOption1))
          defaultBarOptions.series[0].name = this.seriesData[index].name
          defaultBarOptions.series[0].data = this.seriesData[index].data
          defaultBarOptions.series[0].label = this.seriesData[index].label
          Reflect.deleteProperty(defaultBarOptions.series[0], "animationDelay")
          this.$changeOptionsEV(defaultBarOptions.series[0], "chartOption.series." + index, false)
          this.oldBarSeries[index] = defaultBarOptions.series[0]
        } else {
          this.$changeOptionsEV(this.oldBarSeries[index], "chartOption.series." + index, false)
          this.oldBarSeries[index] = this.seriesData[index]
        }
      } else if (type == "line") {
        this.oldBarSeries[index] = this.seriesData[index]
        this.oldBarSeries[index].type = "bar"
        if (this.oldLineSeries[index] == undefined) {
          this.$changeOptionsEV(defaultLineOptions.series[0], "chartOption.series." + index, false)
          this.$changeOptionsEV("", "chartOption.legend.icon", false)
        } else {
          this.$changeOptionsEV(this.oldLineSeries[index], "chartOption.series." + index, false)
          this.$changeOptionsEV("", "chartOption.legend.icon", false)
        }
        this.oldLineSeries[index] = this.seriesData[index]
      }
    },
    barYAxisTypeChangeHandle() {
      const valIndex = arguments[0]
      const index = arguments[1]
      this.$changeOptionsEV(valIndex, "chartOption.series." + index + ".yAxisIndex", false)
    }
  }
}
</script>

<style scoped>
.inlineMiddle {
  display: inline-block;
  vertical-align: middle;
}
.width_100 {
  width: 100%;
}

.percent100 {
  width: 100%;
}

.percent68 {
  width: 68%;
}

.height32 {
  height: 32px;
  line-height: 32px;
}

.percent36 {
  width: 36%;
}

.percent38 {
  width: 38%;
}

.percent56 {
  width: 56%;
}
.color-picker-container .color-text {
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
  color: inherit;
  font-size: 12px;
  max-width: 80%;
}

.item-title-box {
  width: calc(100% - 40px);
  justify-content: space-between;
}

.bar-options-setting-dialog /deep/ .el-collapse-item__header {
  /* min-height: 44px; */
  height: auto;
}

/* 名称和输入框中间的滑块 */
.center-slider {
  width: calc(74% - 86px);
}
</style>
<style>
.number-input-box {
  position: relative;
  display: inline-block;
}

.number-input-box .el-input-number .el-input__inner {
  padding-right: 30px;
  text-align: left;
}
.bar-options-setting-dialog .tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-right: 24px;
}
.bar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
.bar-options-setting-dialog .tabs.home_tabs .tabs-item {
  color: rgba(0, 0, 0, 0.6);
}
.bar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
</style>
